import React, { useState } from 'react';
import { getPathnameIndexInPercent } from '../../../utils/path/path';
import { useHistory } from 'react-router';
import { useForm, SubmitHandler } from 'react-hook-form';
import { postNewLead } from '../../API/lead';
import { useMobile } from '../../../hooks/useMobile';
import { useGetStartedContext } from '../../../contexts/GetStarted';
import { forwardUrlParams } from '../../../utils/url';
import { GetStartedTemplateProps } from './types/get-started-template-props';
import { useStyles } from './styles/get-started-template-styles';
import Banner from '../../BuildingBlocks/GetStarted/Banner';
import NextExitButtons from '../../BuildingBlocks/GetStarted/NextExitButtons';
import ProgressLine from '../../BuildingBlocks/Progress/ProgressLine';
import GetStartedHeader from '../../BuildingBlocks/Headers/GetStartedHeader';

export default function GetStartedTemplate({
  title,
  subtitle,
  progressBar = true,
  progressBarPath,
  backClick,
  continuePath,
  children = null,
  setValue = null,
  control = null,
  handleSubmit,
  disable = false,
  contentBelowButtons,
}: GetStartedTemplateProps) {
  const mobile = useMobile();
  const classes = useStyles();
  const history = useHistory();
  const methods = useForm();
  const { setOnboardingStage, setLeadId } = useGetStartedContext();
  const [loading, setLoading] = useState(false);
  if (!control || !setValue || !handleSubmit) {
    setValue = methods.setValue;
    control = methods.control;
    handleSubmit = methods.handleSubmit;
  }

  const onSubmit: SubmitHandler<any> = async (data) => {
    setLoading(true);
    const id = window.localStorage.getItem('leadId');
    if (id && id !== 'undefined') data.id = id;
    data.onboardingStage = continuePath;
    const res = await postNewLead(data);
    if (!id && res?.id) {
      window.localStorage.setItem('leadId', res?.id);
      setLeadId(res?.id);
    }
    history.push({ pathname: continuePath, search: forwardUrlParams() });
    setOnboardingStage(continuePath);
    setLoading(false);
  };

  return (
    <>
      <Banner />
      <div className={classes.container}>
        {progressBar && (
          <ProgressLine
            progressPercent={getPathnameIndexInPercent(progressBarPath)}
          />
        )}
        <GetStartedHeader mobile={mobile} header={title} subheader={subtitle} />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.questions}>{children}</div>
          <NextExitButtons
            disable={disable || loading}
            loading={loading}
            backClick={backClick}
          />
        </form>
        {contentBelowButtons && (
          <div className={classes.contentBelowButtons}>
            {contentBelowButtons}
          </div>
        )}
      </div>
    </>
  );
}
